import { ExcelPasteConfig } from 'src/hooks/useExcelPaste';
import { SAL6010_R01DetailDto, defaultSAL6010_R01DetailDto } from 'src/containers/mes/SAL/SAL6010_R01/Dto_SAL6010_R01';
import { calculateDetailAmount } from 'src/utils/calculation/calculationUtils';

/**
 * SAL6010 엑셀 붙여넣기 설정
 * 
 * 엑셀 컬럼 순서:
 * | 품목코드 | 품목명 | 규격 | 모델번호 | 단위 | 수량 | 단가 | 할인금액 | 금액 |
 * |   A열   |  B열  | C열 |   D열   | E열 | F열 | G열 |   H열   | I열 |
 */
export const SAL6010_EXCEL_CONFIG: ExcelPasteConfig<SAL6010_R01DetailDto> = {
  // 컬럼 순서 매핑 (엑셀 컬럼 → 숫자 인덱스)
  columnMapping: {
    itemCd: 0,       // A열: 품목코드
    itemNm: 1,       // B열: 품목명
    itemSpec: 2,     // C열: 규격
    modelNo: 3,      // D열: 모델번호
    estimateUnit: 4, // E열: 단위
    estimateQty: 5,  // F열: 수량
    estimatePrice: 6, // G열: 단가
    dcAmt: 7,        // H열: 할인금액
    itemAmt: 8,      // I열: 금액 (자동계산)
  },

  // 컬럼명 → 필드명 매핑
  fieldMappings: {
    'itemCd': 'itemCd',
    'itemNm': 'itemNm',
    'itemSpec': 'itemSpec',
    'modelNo': 'modelNo',
    'estimateUnit': 'estimateUnit',
    'estimateQty': 'estimateQty',
    'estimatePrice': 'estimatePrice',
    'dcAmt': 'dcAmt',
    'itemAmt': 'itemAmt',
  },

  //합계필드 필요없을 경우 
   // autoCompleteFields 제거 (자동완성 비활성화)
  // autoCompleteFields: { ... },  // 이 부분을 제거하거나 undefined로 설정

  // 자동완성 설정 (품목 코드 입력 시)
  autoCompleteFields: {
    searchField: 'itemCd', // 검색할 필드
    searchFunction: async (code: string) => {
      // 실제 구현에서는 useCodeSearch 훅을 사용
      // 여기서는 타입 정의만 제공
      throw new Error('searchFunction은 컴포넌트에서 주입해야 합니다.');
    },
    mapping: {
      // 검색 결과 → 테이블 필드 매핑
      'itemNm': 'itemNm',           // 품명
      'itemSpec': 'itemSpec',       // 규격
      'modelNo': 'modelNo',         // 모델번호
      'itemUnit': 'estimateUnit',   // 단위
      'itemCost': 'estimatePrice',  // 단가
    }
  },

  // 금액 계산 함수
  calculateAmount: (data: SAL6010_R01DetailDto): SAL6010_R01DetailDto => {
    return calculateDetailAmount(data, {
      qtyField: 'estimateQty',
      priceField: 'estimatePrice',
      dcField: 'dcAmt',
      amountField: 'itemAmt',
      preventNegative: true
    });
  },

  // 기본 데이터
  defaultData: defaultSAL6010_R01DetailDto,

  // 모듈명 (로그용)
  moduleName: 'SAL6010'
};

/**
 * SAL2020 엑셀 붙여넣기 설정 (예시)
 * 
 * 엑셀 컬럼 순서:
 * | 품목코드 | 품목명 | 규격 | 단위 | 수량 | 단가 | 금액 |
 * |   A열   |  B열  | C열 | D열 | E열 | F열 | G열 |
 */
export const SAL2020_EXCEL_CONFIG: ExcelPasteConfig<any> = {
  columnMapping: {
    itemCd: 0,       // A열: 품목코드
    itemNm: 1,       // B열: 품목명
    itemSpec: 2,     // C열: 규격
    itemUnit: 3,     // D열: 단위
    itemQty: 4,      // E열: 수량
    itemPrice: 5,    // F열: 단가
    itemAmt: 6,      // G열: 금액
  },
  fieldMappings: {
    'itemCd': 'itemCd',
    'itemNm': 'itemNm',
    'itemSpec': 'itemSpec',
    'itemUnit': 'itemUnit',
    'itemQty': 'itemQty',
    'itemPrice': 'itemPrice',
    'itemAmt': 'itemAmt',
  },
  defaultData: {} as any,
  moduleName: 'SAL2020'
};

/**
 * PUR1030 엑셀 붙여넣기 설정 (예시)
 * 
 * 엑셀 컬럼 순서:
 * | 품목코드 | 품목명 | 규격 | 단위 | 수량 | 단가 | 금액 |
 * |   A열   |  B열  | C열 | D열 | E열 | F열 | G열 |
 */
export const PUR1030_EXCEL_CONFIG: ExcelPasteConfig<any> = {
  columnMapping: {
    itemCd: 0,       // A열: 품목코드
    itemNm: 1,       // B열: 품목명
    itemSpec: 2,     // C열: 규격
    itemUnit: 3,     // D열: 단위
    itemQty: 4,      // E열: 수량
    itemPrice: 5,    // F열: 단가
    itemAmt: 6,      // G열: 금액
  },
  fieldMappings: {
    'itemCd': 'itemCd',
    'itemNm': 'itemNm',
    'itemSpec': 'itemSpec',
    'itemUnit': 'itemUnit',
    'itemQty': 'itemQty',
    'itemPrice': 'itemPrice',
    'itemAmt': 'itemAmt',
  },
  defaultData: {} as any,
  moduleName: 'PUR1030'
};
